export default __webpack_public_path__ + "static/media/03_west_flower_A2.f0b8c209.mp4";